function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrategyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 312.732 312.732",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M85.251,162.746c-2.206,0-4.35-1.145-5.531-3.19c-1.761-3.051-0.716-6.953,2.335-8.714 L261.768,47.085c3.053-1.763,6.952-0.713,8.713,2.335c1.762,3.052,0.717,6.952-2.334,8.715L88.435,161.891 C87.43,162.472,86.333,162.746,85.251,162.746z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#61B4E4"
    },
    cx: 264.958,
    cy: 52.61,
    r: 47.774
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M264.952,266.503c-1.082,0-2.18-0.275-3.184-0.855L82.055,161.891 c-3.051-1.762-4.096-5.663-2.335-8.715c1.761-3.05,5.661-4.099,8.715-2.334l179.712,103.756c3.052,1.763,4.097,5.663,2.334,8.714 C269.301,265.357,267.157,266.503,264.952,266.503z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#61B4E4"
    },
    cx: 264.958,
    cy: 260.122,
    r: 47.774
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#005CB9"
    },
    cx: 85.245,
    cy: 156.366,
    r: 85.245
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyIcon);
export default __webpack_public_path__ + "static/media/StrategyIcon.b45d56c9a30b80b07df003674ef5fbcb.svg";
export { ForwardRef as ReactComponent };